module.exports = __webpack_public_path__ + "img/LUB00013.2655e6c9.png";